import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbTimepickerModule,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { SvgModule } from "assets/svg/svg.module";
import { BrMaskerModule } from "brmasker-ionic-3";
import { IonicModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { DataFilterPipe } from "pipes/output-formatters/data-filter.pipe";
import { DiscDateStatusTransformPipe } from "pipes/output-formatters/disc-date-status-transform";
import { FormatMrnPipe } from "pipes/output-formatters/format-mrn.pipe";
import { SafeUrlPipe } from "pipes/output-formatters/safe-url.pipe";
import { UtcDateTimeZonePipe } from "pipes/output-formatters/utc-date-timezone.pipe";
import { YesNoTransformPipe } from "pipes/output-formatters/yes-no-transform.pipe";
import { PhonePipe } from "../../directive/phone.directive";
import { CloseButtonComponent } from "../../pages/reports/components/close-button/close-button";
import { TabNavigatorComponent } from "../../pages/reports/components/tab-navigator/tab-navigator";
import { AddressSingleLinePipe } from "../../pipes/output-formatters/address-single-line.pipe";
import { CredentialedResourcePipe } from "../../pipes/output-formatters/credentialed-resource.pipe";
import { CurantisDatetimePipe } from "../../pipes/output-formatters/curantis-datetime";
import { CurantisDatePipe } from "../../pipes/output-formatters/CurantisDate";
import { EnumDisplayPipe } from "../../pipes/output-formatters/enum-display.pipe";
import { EnumStringPipe } from "../../pipes/output-formatters/enum-string.pipe";
import { GenericAddressSingleLinePipe } from "../../pipes/output-formatters/generic-address-single-line.pipe";
import { NamedContactPipe } from "../../pipes/output-formatters/named-contact";
import { RawDatePipe } from "../../pipes/output-formatters/raw-date.pipe";
import { ReplaceBlankValue } from "../../pipes/output-formatters/ReplaceBlankValue";
import { UtcDatePipe } from "../../pipes/output-formatters/utc-date.pipe";
import { AvatarPhotoComponent } from "../avatar-photo/avatar-photo.component";
import { CollapsibleModalHeaderComponent } from "../collapsible-modal-header/collapsible-modal-header";
import { FloatingAlertComponent } from "./alerts/floating-alert/floating-alert";
import { ClickInsideDirective } from "./date-picker/click-inside.directive";
import { ClickOutsideDirective } from "./date-picker/click-outside.directive";
import { DatePickerComponent } from "./date-picker/date-picker";
import { NgbCustomParserFormatter } from "./date-picker/ngb-custom-parser-formatter";
import { DateRangePickerComponent } from "./date-range-picker/date-range-picker";
import { ErrorMessageCognitoComponent } from "./error-message-cognito/error-message-cognito";
import { GoalComponent } from "./goal/goal";
import { InterventionComponent } from "./intervention/intervention";
import { IssueComponent } from "./issue/issue";
import { MonthSelector } from "./month-selector/month-selector.component";
import { MultiSelectDropdownComponent } from "./multi-select-dropdown/multi-select-dropdown";
import { MultiSelectInputComponent } from "./multi-select-input/multi-select-input";
import { NavBarComponent } from "./nav-bar/nav-bar";
import { OpenVisitIndicatorComponent } from "./open-visit-indicator/open-visit-indicator";
import { PatientBriefComponent } from "./patient-brief/patient-brief";
import { SearchbarIconClickDirective } from "./searchbar/searchbar-icon-click.directive";
import { SelectPopoverComponent } from "./single-select-dropdown/select-popover-component";
import { SingleSelectDropdownComponent } from "./single-select-dropdown/single-select-dropdown";
import { TimePickerComponent } from "./time-picker/time-picker";
import { TypeableDatePickerComponent } from "./typeable-date-picker/typeable-date-picker";
import { VoiceIonTextArea } from "./voice-ion-textarea/voice-ion-textarea.component";

@NgModule({
  declarations: [
    AvatarPhotoComponent,
    SearchbarIconClickDirective,
    ReplaceBlankValue,
    CurantisDatetimePipe,
    CurantisDatePipe,
    DataFilterPipe,
    UtcDatePipe,
    DiscDateStatusTransformPipe,
    UtcDateTimeZonePipe,
    YesNoTransformPipe,
    FormatMrnPipe,
    SafeUrlPipe,
    IssueComponent,
    GoalComponent,
    InterventionComponent,
    PatientBriefComponent,
    FloatingAlertComponent,
    DatePickerComponent,
    DateRangePickerComponent,
    TimePickerComponent,
    EnumStringPipe,
    PhonePipe,
    AddressSingleLinePipe,
    GenericAddressSingleLinePipe,
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    SelectPopoverComponent,
    NavBarComponent,
    TabNavigatorComponent,
    CloseButtonComponent,
    ClickInsideDirective,
    ClickOutsideDirective,
    EnumDisplayPipe,
    MonthSelector,
    NamedContactPipe,
    RawDatePipe,
    CollapsibleModalHeaderComponent,
    MultiSelectInputComponent,
    TypeableDatePickerComponent,
    CredentialedResourcePipe,
    ErrorMessageCognitoComponent,
    VoiceIonTextArea,
    OpenVisitIndicatorComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
    NgbDatepickerModule.forRoot(),
    NgbTimepickerModule.forRoot(),
    CommonModule,
    TruncateModule,
    SvgModule,
    FontAwesomeModule,
  ],
  exports: [
    ReplaceBlankValue,
    CurantisDatetimePipe,
    CurantisDatePipe,
    DataFilterPipe,
    UtcDatePipe,
    DiscDateStatusTransformPipe,
    UtcDateTimeZonePipe,
    YesNoTransformPipe,
    FormatMrnPipe,
    SafeUrlPipe,
    GenericAddressSingleLinePipe,
    IssueComponent,
    GoalComponent,
    InterventionComponent,
    PatientBriefComponent,
    FloatingAlertComponent,
    MonthSelector,
    DatePickerComponent,
    DateRangePickerComponent,
    TimePickerComponent,
    CredentialedResourcePipe,
    PhonePipe,
    AddressSingleLinePipe,
    EnumStringPipe,
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    NavBarComponent,
    TabNavigatorComponent,
    CloseButtonComponent,
    ClickInsideDirective,
    ClickOutsideDirective,
    SearchbarIconClickDirective,
    NamedContactPipe,
    EnumDisplayPipe,
    RawDatePipe,
    BrMaskerModule,
    CollapsibleModalHeaderComponent,
    MultiSelectInputComponent,
    TypeableDatePickerComponent,
    AvatarPhotoComponent,
    ErrorMessageCognitoComponent,
    VoiceIonTextArea,
    OpenVisitIndicatorComponent,
  ],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbCustomParserFormatter },
    NamedContactPipe,
  ],
  entryComponents: [SelectPopoverComponent],
})
export class CommonComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/common/common-components.module.ts